// @ts-nocheck
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';

// import { getData, postData } from "../../Axios/axiosData";

const initialState = {
  Payrolls: [],
  loading: false,
  error: null,
  Payroll: [],
  PaymentMethodList: [],
  //~~~~~~~~~~
  PayrollById: {},
  loadingById: false,
  errorById: null
};

export const addPayroll = createAsyncThunk('Pyrolls/AddPayroll', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.post('Payroll/AddPayroll', item);
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});
export const updatePayroll = createAsyncThunk('Pyrolls/updatePayroll', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.post('Payroll/UpdatePayroll', item);
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const getPayrolls = createAsyncThunk('Pyrolls/getPayrolls', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    // const data = await getData("Payroll/GetPayrollList");
    const { data } = await ntxAPI.get('Payroll/GetPayrollList');
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});
export const getPayrollById = createAsyncThunk('Pyrolls/getPayrollById', async (id, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.get(`Payroll/GetPayrollTimePeriodById?Id=${id}`);
    return data.data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const GetPaymentMethod = createAsyncThunk(
  'Pyrolls/GetPaymentMethod',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      // const data = await getData("Payroll/GetPaymentMethodList");
      const { data } = await ntxAPI.get('Payroll/GetPaymentMethodList');
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

const PayrollSlice = createSlice({
  name: 'Pyrolls',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      /////// get all Payrolls
      .addCase(getPayrolls.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPayrolls.fulfilled, (state, action) => {
        state.loading = false;
        state.Payrolls = action.payload;
      })
      .addCase(getPayrolls.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      /////// get Payroll By Id
      .addCase(getPayrollById.pending, state => {
        state.loadingById = true;
        state.errorById = null;
      })
      .addCase(getPayrollById.fulfilled, (state, action) => {
        state.loadingById = false;
        state.PayrollById = action.payload;
      })
      .addCase(getPayrollById.rejected, (state, action) => {
        state.loadingById = false;
        state.errorById = action.payload;
      })

      /////// get PaymentMethodList
      .addCase(GetPaymentMethod.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetPaymentMethod.fulfilled, (state, action) => {
        state.loading = false;
        state.PaymentMethodList = action.payload;
      })
      .addCase(GetPaymentMethod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// Add all Payrolls
      .addCase(addPayroll.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPayroll.fulfilled, (state, action) => {
        state.loading = false;
        state.Payrolls.push(action.payload);
      })
      .addCase(addPayroll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default PayrollSlice.reducer;
